import React from 'react';
import { useMainPerformanceSmsChargeNegativeDays } from '../../../hooks/useMainPerformanceKPIs';
import KPICard from '../../ui/KPICard';
import LoadingSpinner from '../../ui/LoadingSpinner';
import ErrorMessage from '../../ui/ErrorMessage';
import { KPIProps } from '../../../types/kpi';
import { formatNumber } from '../../../utils/formatters';

const SmsChargeNegativeDaysKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange = 'last6Months',
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useMainPerformanceSmsChargeNegativeDays(branchId, timeRange);

  // Handle error callback
  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`animate-enter animate-delay-4 ${className}`}>
        <div className="card-base card-padding">
          <div className="flex items-center justify-center h-32">
            <LoadingSpinner variant="minimal" size="md" />
          </div>
        </div>
      </div>
    );
  }

  if (isError && error) {
    return (
      <ErrorMessage 
        message="خطا در دریافت روزهای منفی شارژ پیامک"
        onRetry={() => refetch()}
        className={className}
      />
    );
  }

  const totalDays = data?.totalDays || 0;
  const monthsWithNegativeDays = data?.monthsWithNegativeDays || 0;

  return (
    <KPICard
      title="روزهای بدون شارژ پیامک"
      value={`${formatNumber(totalDays)} روز`}
      subtitle={`${formatNumber(monthsWithNegativeDays)} ماه دارای روز بدون شارژ`}
      variant="warning"
      accentStyle="corner"
      className={`animate-enter-up stagger-4 ${className}`}
      loading={isLoading && !showLoading}
    />
  );
};

export default SmsChargeNegativeDaysKPI;